import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import styles from './styles.module.less';
import FormattedCurrency from '../../../../../components/formatted-currency/';
import { CurrencyPropType } from '../../../../../prop-types/currency';
import messages from '../../messages';

const defaultReason = [<FormattedMessage {...messages.defaultAdjustmentReason} key='default-adjustment-reason' />];

const getReasonsFromDescription = (description) => {
  const reasons = description?.split('. ').reduce((aR, r, index, splitReasons) => {
    const isLastElement = index === splitReasons.length - 1;
    const sanitizedReason = isLastElement ? r : `${r}.`;
    if (r.length) {
      return [...aR, sanitizedReason];
    }
    return aR;
  }, []);
  return reasons?.length ? reasons : defaultReason;
};

export const AdjustmentBreakdown = ({ adjustmentData: { description, transactionTotal } }) => {
  const adjustmentReasons = getReasonsFromDescription(description);

  return (
    <div className={styles['cost-breakdown']}>
      <h4>
        <FormattedMessage {...messages.adjustmentBreakdown} />
      </h4>
      <ul>
        {adjustmentReasons.map((adjustmentReason) => (
          <BannerMessageV2
            key={adjustmentReason}
            className={styles['adjustment-reason']}
            content={<li>{adjustmentReason}</li>}
            status={BannerStatus.Info}
          />
        ))}
      </ul>
      <div className={styles['line-item']}>
        <div>
          <FormattedMessage {...messages.amountAdjusted} />
        </div>
        <FormattedCurrency currencyCode={transactionTotal.code} value={Math.abs(transactionTotal.value)} />
      </div>
      <div className={styles.total}>
        <span>
          <FormattedMessage {...messages.adjustmentTotal} />
        </span>
        <FormattedCurrency currencyCode={transactionTotal.code} value={Math.abs(transactionTotal.value)} />
      </div>
    </div>
  );
};

AdjustmentBreakdown.propTypes = {
  adjustmentData: PropTypes.shape({
    transactionTotal: CurrencyPropType.isRequired,
    description: PropTypes.string,
  }).isRequired,
};
